<template>
    <b-modal
        ref="product-placement-add-modal"
        cancel-variant="outline-secondary"
        size="lg"
        centered
        title="Add component"
        hide-footer
    >
        <AddPlacementComponent
            @created="created"
        />
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import AddPlacementComponent from "@core/components/product/placement-component/AddPlacementComponent";

export default {
    components: {
        AddPlacementComponent, BModal,
    },
    methods: {
        created(product) {
            this.$refs['product-placement-add-modal'].hide();
            this.$emit('created', product);
        },
        show() {
            this.$refs['product-placement-add-modal'].show();
        },
    }
}
</script>
